var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multi-selector"},_vm._l((_vm.items),function(item){return _c('button',{class:{
      selected: _vm.isArray ? _vm.value.includes(item[_vm.values]) : _vm.value == item[_vm.values]
    },attrs:{"type":"button"},on:{"click":function($event){return _vm.select(item)}}},[_vm._v(" "+_vm._s(item[_vm.labels])+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }